import React from "react";
import { Toaster } from "react-hot-toast";

/**
 * AuthLayout - Simple layout wrapper for authentication pages
 * Minimal layout with just Toaster for notifications
 */
const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#0D0D0D] text-text1">
      <Toaster />
      {children}
    </div>
  );
};

export default AuthLayout;
